import ModalCloseButton from '../../../../Component/UI/ModalCloseButton';
/* eslint-disable react/jsx-pascal-case */
import { useEffect, useRef } from "react";
import styled from "styled-components";
import {
  BackgroundArea,

  RowView,
  TitleArea,
} from "../../../../Component/style/common_style";
import { modalProps } from "../../../../Component/Interface/Modal";

interface BuyCompModalOpen extends modalProps {
  onClose: () => void;
}

const Overlay = styled(BackgroundArea)`
  background-color: rgba(0, 0, 0, .32);
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: calc(100% - 32px);
  max-width: 27rem;
  margin: auto 0rem;
  background-color: var(--user-surface-raised);
  border: 1px solid var(--user-border);
  box-shadow: 0 16px 48px rgba(0, 0, 0, .3);
  color: var(--user-text);
  border-radius: 24px;
  overflow: hidden;
  padding: 24px 24px 30px 24px;
  z-index: 99;
  color: var(--user-text);
  div.info {
    line-height: 25px;
  }
`;

const Title_Box = styled.div`
  box-sizing: border-box;
  min-height: 44px;
  padding-inline: 44px;
  align-items: center;
  text-align: center;
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
`;

const Exit_Btn = styled(ModalCloseButton)`  position: absolute;
  right: 0px;
`;

const Content_Box = styled.div`
  padding: 20px 0px 2px 0px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  color: var(--user-text);
`;

const BtnArea = styled(RowView)`
  margin-top: 1.5rem;
  button {
    min-height: 48px;
    font-size: 16px;
    &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 3px; }
    border: 0;
    flex: 1;
    padding: 0.8rem 0rem;
    font-family: var(--font-Pretendard-SemiBold);
    text-align: center;
    color: white;
    background: linear-gradient(90deg, #7955f0, #3209b9);
    border-radius: 8px;
    cursor: pointer;
  }
`;

const Buy_Complete_Modal = (props: BuyCompModalOpen) => {
  const isOpen = props.visible;
  const setIsOpen = props.handleModal;
  const closeModal = () => {
    setIsOpen();
    props.onClose();
  };
  const closeRef = useRef(closeModal);
  closeRef.current = closeModal;

  useEffect(() => {
    if (!isOpen) return;
    const timer = window.setTimeout(() => closeRef.current(), 1000);
    return () => window.clearTimeout(timer);
  }, [isOpen]);

  return (
    <Overlay style={isOpen ? {} : { display: "none" }} translate="no"
      onClick={event => { if (event.target === event.currentTarget) closeModal(); }}>
      <ModalBox role="dialog" aria-modal="true" aria-label="구매 완료" onClick={event => event.stopPropagation()}>
        <Title_Box>
          <div>구매완료</div>
          <Exit_Btn aria-label="구매 완료 닫기" onClick={closeModal} />
        </Title_Box>

        <Content_Box className="info">
          구매가 완료되었어요!
          <br />
          방송이 종료되면 카카오톡으로 정산서를 발송해 드릴게요.
        </Content_Box>

        <BtnArea>
          <button type="button" onClick={closeModal}>확인</button>
        </BtnArea>
      </ModalBox>
    </Overlay>
  );
};

export default Buy_Complete_Modal;
